module.exports = __webpack_public_path__ + "static/media/background.e07e3b94.png";